import React from 'react';
import { RowLoader } from '../component-loader';

const MagazineLandingPage = () => {
  return <RowLoader />;
};

export default MagazineLandingPage;
